class Interactive {
  listElems = null
  constructor(elem) {
    this.listElems = elem.querySelectorAll('li')
    console.log(this.listElems)
    for (let list of this.listElems) {
      list.addEventListener('mouseover', () => {
        this.reset()
        list.classList.toggle('active')
      })
    }

    this.listElems[0].classList.toggle('active')
  }

  reset() {
    for (let list of this.listElems) {
      list.classList.remove('active')
    }
  }
}

export default Interactive
